export const environment = {
  production: false,
  apiUrl: 'https://ems-dev.gdnemorocco.com/api', 
  aiAssistantApiUrl: '/chatbot',
  useAiDocumentMocks: false,
  showDashboard: true,
  showCardsView: true,
  showListView: true,
  showValidationMenu: true,
  showClient: true,
  showProject: true,
  showStaff: true,
  showPoolMenu: true,
  showOrganisation: true,
  showPosts: true,
  showTasks: true,
  showPromotion: true,
  showEvaluationMenu: true,
  showGroup: true,
  showService: true,
  showProcess: true,
  showAuditLogMenu: true,
  showGlobalTab: true,
  showClientTab: true,
  showLeaderTab: true,
  showLanguageTab: true,
  showPromotionTab: true,
  showMedicalVisitTab: true,
  showTechnologies: true,
  showSkillCategories: true,
  showSectors: true,
  showNearshores: true,
  showClusters: true,
  showOffshoreLevels: true,
  showPractices: true,
  showCategories: true,
  showCountries: true,
  showRegions: true,
  showStatuses: true,
  showRuntimeSettings: true,
  showDocumentTemplates: true,
  showStaffedRoles: true,
  showWorkingHours: true,
  showGuardConfiguration: true,
  showJiraProjectKeys: true,
  showInvoicingProjectAccounts: true,
  showInvoicingSettings: true,
  showCurrency: true,
  showCurrencyExchange: true,
  showEvaluation: true,
  showPermissions: true,
  showUsers: true,
  showRoles: true,
  showEmployeeImport: true,
  showStaffedRoleImport: true,
  showSalaryImport: true,
  showClientImport: true,
  showProjectImport: true,
  showActivityImport: true,
  feedbackRouteVisibility: {
    hiddenPrefixes: ['finance', 'auth', 'payroll', 'salary', 'audit-log', 'configurations', 'details', 'edit-employee'],
    hiddenExactRoutes: ['auth'],
  },
};
